import { useEffect } from 'react';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const WebSocketConnection = () => {
  const { host } = Selectors.useWebSocketConnection();
  const fetchWebsocket = Events.useFetchWebsocket();
  const processMessage = Events.useProcessMessage();

  useEffect(() => {
    if (!host) { return undefined; }
    const webSocket = new WebSocket(host);
    webSocket.onmessage = (processMessage);
    webSocket.onclose = () => setTimeout(fetchWebsocket, 60000);
    webSocket.onerror = () => webSocket.close();

    return () => webSocket.close();
  }, [host]);
};

export default WebSocketConnection;
